// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupPolling_wrapper__L40lE"};